"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/**
 * 战略配售可出借信息详情
 */
require("../../src/modules/singlestocktop/web");
var web_1 = __importDefault(require("../../config/web"));
var fieldtools_1 = __importDefault(require("../../src/modules/commonutil/fieldtools"));
var colors = {
    "SPJ": "#ff0101",
    "LIMITSHARES": "#90c320",
    "UNLIMITSHARES": "#22ab37",
    "LENDSHARES": "#00a1ea",
    "LENDBALANCE": "#ac4adb",
    "LIMITBALANCE": "#004986",
    "STOCKRATE": "#ff8a00",
    "SURPLUSRATE": "#008fce"
};
var names = {
    "SPJ": "收盘价(右)",
    "LIMITSHARES": "限售股(左)",
    "UNLIMITSHARES": "非限售股(左)",
    "LENDSHARES": "可出借股份(左)",
    "LENDBALANCE": "出借余量(左)",
    "LIMITBALANCE": "可出借上限容量(左)",
    "STOCKRATE": "可出借股份占非限售股的比例(左)",
    "SURPLUSRATE": "可出借余量占非限售股的比例(左)"
};
var chartdata = {
    "TDATE": [],
    "SPJ": [],
    "LIMITSHARES": [],
    "UNLIMITSHARES": [],
    "LENDSHARES": [],
    "LENDBALANCE": [],
    "LIMITBALANCE": [],
    "STOCKRATE": [],
    "SURPLUSRATE": []
};
var echart = echarts.init(document.getElementById("chart"));
loadchartdata();
loadtable();
loadevent();
function loadevent() {
    $('input[type=radio][name=chart]').change(function () {
        loadchart($(this).data("type"));
    });
    window["datechange"] = function (dp) {
        //dp.cal.getNewDateStr()
        location.href = "/zcz/zlpskcj.html?t=" + dp.cal.getNewDateStr();
    };
}
function loadtable() {
    $("#dataview").emdataview({
        dataurl: {
            hostname: 'datacenter',
            url: 'api/data/v1/get',
            params: {
                columns: "ALL",
                token: '894050c76af8597a853f5b408b759f5d',
                reportName: "RPTA_CUSTOM_WEB_KCBZLPSKCJ",
                filter: "(SCODE=\"" + stockInfo.code + "\")"
            }
        },
        sortname: "TDATE",
        pagesize: 50,
        columns: {
            "TDATE": {
                formatter: function (value, item, i, field) {
                    return "<a href=\"/zcz/zlpskcj.html?t=" + fieldtools_1["default"].dateformat(value) + "\">" + fieldtools_1["default"].dateformat(value) + "</a>";
                }
            },
            "xg": {
                formatter: function (value, item, i, field) {
                    return "<a class=\"red\" href=\"/zcz/zlpskcj.html?t=" + fieldtools_1["default"].dateformat(item.TDATE) + "\">\u5F53\u65E5\u4FE1\u606F</a>";
                }
            },
            "SPJ": {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { num: 2, showcolor: true, colorvalue: item.ZDF });
                }
            },
            "ZDF": {
                formatter: function (value, item, i, field) {
                    return fieldtools_1["default"].fieldfmt(value, { num: 2, showcolor: true, fix: "%" });
                }
            },
            "LIMITSHARES": {
                formatter: { omit: false, num: 2 }
            },
            "UNLIMITSHARES": {
                formatter: { omit: false, num: 2 }
            },
            "LENDSHARES": {
                formatter: { omit: false, num: 2 }
            },
            "LENDBALANCE": {
                formatter: { omit: false, num: 2 }
            },
            "LIMITBALANCE": {
                formatter: { omit: false, num: 2 }
            },
            "STOCKRATE": {
                formatter: { omit: false, num: 2, fix: "%", zoom: 2 }
            },
            "SURPLUSRATE": {
                formatter: { omit: false, num: 2, fix: "%", zoom: 2 }
            },
        }
    });
}
function loadchart(key) {
    var option = {
        title: {
            left: 'center'
        },
        tooltip: {
            trigger: 'axis',
            formatter: function (data) {
                var str = "";
                var date = data[0].axisValue;
                for (var i = 0; i < data.length; i++) {
                    if (!fieldtools_1["default"].isEmpty(data[i].value)) {
                        if (data[i].seriesName == "收盘价(右)")
                            str += data[i].marker + data[i].seriesName + ':' + data[i].value + '元<br/>';
                        else if (data[i].seriesName == "可出借股份占非限售股的比例(左)" || data[i].seriesName == "可出借余量占非限售股的比例(左)")
                            str += data[i].marker + data[i].seriesName + ':' + fieldtools_1["default"].fieldfmt(data[i].value, { num: 2 }) + '%<br/>';
                        else
                            str += data[i].marker + data[i].seriesName + ':' + data[i].value + '万股<br/>';
                    }
                }
                return date + '<br/>' + str;
            }
        },
        legend: {
            right: 20,
            show: false
        },
        grid: {
            x: '7%',
            y: '12%',
            width: '89%',
            height: '75%'
        },
        xAxis: {
            type: 'category',
            data: chartdata.TDATE,
            axisTick: { show: false },
            axisLabel: {
                textStyle: {
                    color: '#000'
                }
            },
            axisLine: {
                show: true,
                lineStyle: { color: "#bbb" }
            },
            splitLine: {
                show: false,
                lineStyle: {
                    type: 'dotted',
                    color: "#dde9f3"
                }
            }
        },
        yAxis: [
            {
                type: 'value',
                scale: true,
                name: (key == "STOCKRATE" || key == "SURPLUSRATE") ? '单位：%' : '单位：万股',
                nameTextStyle: { color: '#000' },
                axisTick: { show: false },
                axisLabel: {
                    textStyle: {
                        color: '#000'
                    }
                },
                axisLine: {
                    show: true,
                    lineStyle: { color: "#bbb" }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'dotted',
                        color: "#dde9f3"
                    }
                }
            },
            {
                type: 'value',
                scale: true,
                name: '单位：元',
                nameTextStyle: { color: '#000' },
                axisTick: { show: false },
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: true,
                    lineStyle: { color: "#bbb" }
                },
                axisLabel: {
                    textStyle: {
                        color: '000'
                    }
                }
            }
        ],
        series: [
            {
                name: "收盘价(右)",
                data: chartdata["SPJ"],
                yAxisIndex: 1,
                connectNulls: true,
                symbol: "circle",
                showSymbol: false,
                itemStyle: {
                    color: colors["SPJ"],
                    normal: {
                        color: colors["SPJ"],
                        borderColor: colors["SPJ"]
                    }
                },
                lineStyle: {
                    width: 1
                },
                type: 'line'
            },
            {
                name: names[key],
                data: chartdata[key],
                connectNulls: true,
                symbol: "circle",
                showSymbol: false,
                itemStyle: {
                    color: colors[key],
                    normal: {
                        color: colors[key],
                        borderColor: colors[key]
                    }
                },
                lineStyle: {
                    width: 1
                },
                type: 'line'
            }
        ]
    };
    echart.setOption(option);
}
function loadchartdata() {
    $.ajax({
        url: web_1["default"].getWebPath("datacenter") + "api/data/v1/get",
        type: "GET",
        dataType: "jsonp",
        data: {
            columns: "ALL",
            token: '894050c76af8597a853f5b408b759f5d',
            reportName: "RPTA_CUSTOM_WEB_KCBZLPSKCJ",
            filter: "(SCODE=\"" + stockInfo.code + "\")",
            sortColumns: "TDATE",
            sortTypes: -1,
            pageSize: 500
        }
    }).then(function (json) {
        if (json && json.result && json.result.data) {
            var arr = json.result.data;
            for (var i = arr.length - 1; i >= 0; i--) {
                var item = arr[i];
                chartdata.TDATE.push(fieldtools_1["default"].dateformat(item.TDATE));
                chartdata.SPJ.push(item.SPJ);
                chartdata.LIMITSHARES.push(item.LIMITSHARES);
                chartdata.UNLIMITSHARES.push(item.UNLIMITSHARES);
                chartdata.LENDSHARES.push(item.LENDSHARES);
                chartdata.LENDBALANCE.push(item.LENDBALANCE);
                chartdata.LIMITBALANCE.push(item.LIMITBALANCE);
                chartdata.STOCKRATE.push(item.STOCKRATE * 100);
                chartdata.SURPLUSRATE.push(item.SURPLUSRATE * 100);
            }
            loadchart("LIMITSHARES");
            if (arr.length > 0)
                $("#search_date").val(fieldtools_1["default"].dateformat(arr[0].TDATE));
        }
    });
}
